import React from "react";

export default function IncomeTotals({ incomes }) {
  return (
    <tr>
      <td className="alignLeft hideBorders">Income</td>
      <td className="hideBorders">{incomes.month1}</td>
      <td className="hideBorders">{incomes.month2}</td>
      <td className="hideBorders">{incomes.month3}</td>
      <td className="hideBorders">{incomes.month4}</td>
      <td className="hideBorders">{incomes.month5}</td>
      <td className="hideBorders">{incomes.month6}</td>
      <td className="hideBorders">{incomes.month7}</td>
      <td className="hideBorders">{incomes.month8}</td>
      <td className="hideBorders">{incomes.month9}</td>
      <td className="hideBorders">{incomes.month10}</td>
      <td className="hideBorders">{incomes.month11}</td>
      <td className="hideBorders">{incomes.month12}</td>
    </tr>
  );
}
